import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import Icon from "../icon/icon.component.jsx"
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
const uuidv4 = require('uuid/v4')

class QuoteItemInvoiced extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            item: this.props.value || null,
            type: this.props.type || 'quote',
            editable: this.props.editable || false,
            uniqueId: uuidv4(),
            onChange: this.props.onChange || function () { },
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            item: nextProps.value || null,
        })
    }

    render() {
        if (!this.state.item) {
            return null
        }
        const invoicedMeasure = parseFloat(this.state.item.attributes.invoicedMeasure)
        const totalMeasure = parseFloat(this.state.item.attributes.totalMeasure)
        if (invoicedMeasure === 0) {
            return null
        }
        let color = (invoicedMeasure === totalMeasure) ? 'custom-secondary' : 'secondary'
        return <div className={"mr-1 " + this.state.className}>
            <OverlayTrigger
                placement={"top"}
                trigger={["hover", "focus"]}
                overlay={
                    <Tooltip
                        tooltipId='tooltip_reserved_inventory'
                    >
                        <FormattedMessage
                            id="quote.edit.inventory.invoiced_items"
                            defaultMessage="{count}/{total} invoiced"
                            values={{
                                count: invoicedMeasure,
                                total: totalMeasure,
                            }}
                        />
                    </Tooltip>}
            >
                <span
                    id={this.state.uniqueId}
                    className={'badge badge-pill mt-1 badge-' + color}
                    data-toggle="dropdown"
                    aria-haspopup="false" aria-expanded="false">
                    <Icon value={'invoice'} className={"px-1"} />
                    <FormattedMessage
                        id="quote.edit.inventory.invoiced_items_short"
                        defaultMessage="{count}/{total}"
                        values={{
                            count: invoicedMeasure,
                            total: totalMeasure,
                        }}
                    />
                </span>
            </OverlayTrigger>
        </div>

    }

}

export default QuoteItemInvoiced





// WEBPACK FOOTER //
// ./src/common/quote/iteminvoiced.component.jsx